import React, { useEffect, useMemo, useState } from 'react';
import { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import { videoAITagPlaceholder } from '../../constants/placeholder';
import './index.scss';
import CustomSelect from '../../components/CustomSelect';
import { useGetCustomSelectButtonElement, useSetSelectDefaultValue } from '../../hooks/init';
import { OptionsType } from '../../utils/customSelectUtils';
import { LocaleType } from '@intelligence/components/LogicSelectBtn';

export default function VideoAITagSelect({
  onChange,
  defaultValue,
  filterValue,
  filterOptions,
  lang,
}: SingleCommonType) {
  const { formatMessage } = useIntl();
  const [searchValue, setSearchValue] = useState('');
  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  function dealwithVideoTag(
    videoTagOptions: Array<{ label_zh: string; label_en: string }>,
    filter?: string,
    lang: LocaleType = 'zh-CN',
  ) {
    if (!videoTagOptions) {
      return [];
    }
    const result: Array<{ text: string; value: string }> = [];

    videoTagOptions.forEach(({ label_zh, label_en }: any) => {
      const text = lang === 'zh-CN' ? label_zh : label_en;
      // 过滤部分数据
      if (filter) {
        const flag = !text.toLowerCase().includes(filter.toLowerCase());
        if (flag) return;
      }
      result.push({
        text,
        value: label_en,
      });
    });

    return result;
  }

  const options: OptionsType = useMemo(() => {
    return dealwithVideoTag(filterOptions, searchValue, lang);
  }, [filterOptions, searchValue, lang]);

  const basicOptions: OptionsType = useMemo(() => {
    return dealwithVideoTag(filterOptions, '', lang);
  }, [filterOptions, lang]);

  const {
    selects: selectVideoTag,
    setSelects: setSelectVideoTag,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'video_tags',
    options: basicOptions.map((item) => item.value),
  });

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'videoAITag',
      commonBackInfo(
        { video_tags: selectVideoTag },
        { videoTag: text },
        { isAll, needChangeEntity: true },
      ),
    );
  }, [selectVideoTag, formatMessage]);

  return (
    <div
      className={`dbo-video-ai-tag-select-wrapper ${diffClassName}`}
    >
      <CustomSelect
        ref={customSelectRef}
        placeholderText={videoAITagPlaceholder[lang]}
        options={options}
        matchButtonWidth
        basicOptions={basicOptions}
        allShowModal="text"
        allLabel={formatMessage({ id: 'Video AI Tags' })}
        searchInfo={[searchValue, setSearchValue]}
        selectOptionsInfo={[selectVideoTag, setSelectVideoTag]}
        onClear={() => setSelectVideoTag([])}
        pointKey={FilterButtonPoint.videoAITag}
      ></CustomSelect>
    </div>
  );
}